/**
 * Created by minh on 23/6/2016.
 */

var taricAdco = angular.module('taric.adco', ['taric.adco.lookup', 'taric.adco.view', 'taric.model.adcotype']);
taricAdco.config(function ($stateProvider) {
    $stateProvider.state('taric.adco', {
        abstract: true,
        url: '/adco',
        template: '<ui-view></ui-view>'
    }).state('taric.adco.lookup', {
        url: '/lookup?frm&sd&ad&mo',
        templateUrl: 'taric/adco/lookup/adco-lookup.tmpl.html',
        controller : 'TaricAdcoLookupController as taricAdcoLookupCtrl',
        resolve: {
            initializeSearchCriteria: function(TaricAdcoLookupModel, $stateParams, CommonHelper){
                TaricAdcoLookupModel.resetSearchCriteria();
                TaricAdcoLookupModel.resetSearchResult();

                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        TaricAdcoLookupModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.ad && $stateParams.ad.length === 4){
                    TaricAdcoLookupModel.getSearchCriteria().additionalCodeType = $stateParams.ad.substr(0,1);
                    TaricAdcoLookupModel.getSearchCriteria().additionalCode = $stateParams.ad.substr(1,3);
                }

                if ($stateParams.mo && $stateParams.mo === 'true'){
                    TaricAdcoLookupModel.getSearchCriteria().meursingOnly = true;
                } else {
                    TaricAdcoLookupModel.getSearchCriteria().meursingOnly = false;
                }
            },
            additionalCodeTypes: function(TaricAdcoLookupModel, AdditionalCodeTypeModel){
                return AdditionalCodeTypeModel.queryAdditionalCodeTypes(TaricAdcoLookupModel.getSearchCriteria().meursingOnly);
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/adco');
            },
            
            setupMenu: function (MenuModel) {
            	
            	MenuModel.setHelpIndex(this.name);
            	MenuModel.notifyObservers();
            }
        }
    }).state('taric.adco.view', {
        url: '/view?sd&ad',
        templateUrl: 'taric/adco/view/adco-view.tmpl.html',
        controller : 'ViewAdcoController as viewAdcoCtrl',
        resolve: {
            additionalCode : function (AdditionalCodePopupModel, $stateParams, CommonHelper){
                if ($stateParams.sd && $stateParams.ad && $stateParams.ad.length === 4){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        return AdditionalCodePopupModel.findAdditionalCode($stateParams.ad, inputDate);
                    }
                }

                return null;
            },
            simulationDate : function ($stateParams, CommonHelper){
                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        return inputDate;
                    }
                }

                return null;
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/nomenclature/sbt');
            },

            setupMenu: function (MenuModel) {
            	
            	MenuModel.setHelpIndex(this.name);
            	MenuModel.notifyObservers();
            }
        }
    });
});


// WEBPACK FOOTER //
// ./app/taric/adco/taric-adco.js